
window.application.register("radio", 
	// <fieldset 
	//data-controller="radio" 
	//data-radio-value="male"
	//name="gender" data-target="form.input">
	// 	<label>
	// 	  <input 
	//       data-target="radio.option"
	//       data-action="radio#select"
	//       type="radio"  name="gender" value="male">
	//       Male
	//     </label>
	//     <label>
	// 	  <input 
	//       data-target="radio.option" 
	//       data-action="radio#select"
	//       type="radio"  name="gender" value="female">
	//       Female
	//     </label>
	// </fieldset>
	class extends Stimulus.Controller {
		static get targets() {
		  return [ "option" ]
		}
		connect(){
			this.element[this.identifier] = this;
			this.render();
		}
		render(){
			this.optionTargets.map((el)=>{
				if(this.value == el.value){
					el.checked = true;
				}
			})
		}
		select(e){
			this.value = e.currentTarget.value;
		}
		get value(){
			return this.data.get('value')
		}
		set value(val){
			this.data.set('value', val);
			this.render();
		}
	}
)

window.application.register("money", 
	// <input 
 //    data-controller="money"
 //    data-money-value="100"
 //    data-money-currency="₱"   
 //    data-money-step="1"
 //    type="number"
 //    name="monthlyIncome"
 //    autocomplete="off"
 //    required
 //    >

	class extends Stimulus.Controller {
		connect(){
			//expose controller to element["money"]
			this.element[this.identifier] = this;
			this.element.addEventListener('focusin', this.onFocusIn.bind(this));
			this.element.addEventListener('focusout', this.onFocusOut.bind(this));
			this.element.addEventListener('change', this.onChange.bind(this));	
			if(this.value){
				this.element.value = this.value;
			}
			this.onFocusOut();
		}
		
		disconnect(){
			try{
				this.tearDown();
			}catch(err){
			}
		}

		tearDown(){
			this.element.removeEventListener('focusin', this.onFocusIn.bind(this));
			this.element.removeEventListener('focusout', this.onFocusOut.bind(this));	
			this.element.removeEventListener('change', this.onChange.bind(this));		
		}
		onFocusIn(e){
			this.element.value = this.element.value.replace(/,/g, '');
			if(this.data.get('currency')){
				this.element.value = this.element.value.replace(this.data.get('currency')+' ','');	
			}			
			if(this.element.value=='0.00'){
				this.element.value='';
			}
			this.element.setAttribute('type','number');
		}
		onChange(e){
			this.value = this.element.value;
		}
		onFocusOut(e){
			var n = parseFloat(this.element.value?this.element.value:0);
			if(this.data.get('step') && parseInt(this.data.get('step'))){
				n=n%parseInt(this.data.get('step'))==0?n:Math.floor(n/parseInt(this.data.get('step')));
			}
			var parts = n.toFixed(2).split(".");
			var money = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + (parts[1] ? "." + parts[1] : "");
			this.element.setAttribute('type', 'text');
			if(this.data.get('currency')){
				money = this.data.get('currency')+' '+money;
			}
			this.element.value = money;
		}

		get value(){
			return this.data.get('value')
		}

		set value(val){
			this.data.set('value', val);
		}
	}
)

window.application.register("date", 
	// <input 
 //    data-controller="date"   
 //    data-date-min-date="<%=moment().subtract(58, 'years').format('MMMM DD YYYY');%>"
 //    data-date-max-date="<%=moment().subtract(18, 'years').format('MMMM DD YYYY');%>"
 //    data-date-format="F j Y"
 //    type="date"
 //    name="date"
 //    autocomplete="off"
 //    required>
	class extends Stimulus.Controller {
		connect(){
			
			//expose controller to element["date"]
			this.element[this.identifier] = this;
			var opts = {};
			if(this.data.get('format')){
				opts.dateFormat = this.data.get('format')
			}
			if(this.data.get('minDate')){
				opts.minDate = this.data.get('minDate');
			}
			if(this.data.get('maxDate')){
				opts.maxDate = this.data.get('maxDate');
			}
			opts.disableMobile = true;
			if(!this.element.fp){
				this.element.fp = flatpickr(this.element, opts);	
			}
			if(this.element.value){
				this.value = this.element.value;
			}else{
				
			}
			this.element.addEventListener("change", this.onChange.bind(this));
		}
		onChange(e){
			this.value = this.element.value;
		}
		disconnect(){
			try{this.tearDown()}catch(err){};
		}
		tearDown(){
			this.element.removeEventListener("change", this.onChange.bind(this));	
		}
		set value(val){
			if(this.element.getAttribute('value') !== val){
				this.element.setAttribute('value', val);	
			}
			this.data.set('value', val);
			this.element.fp.setDate(val);
		}
		get value(){
			return this.element.fp.parseDate(this.data.get('value'), this.data.get('dateFormat'))
		}
	}
)


window.application.register("checkbox", 
	class extends Stimulus.Controller {
		static get targets() {
		  return [ "option" ]
		}
		connect(){
			this.element[this.identifier] = this;
		}
		select(e){
			var valueArray = JSON.parse(this.value);
			if(e.currentTarget.checked && !valueArray.includes(e.currentTarget.value)){
				valueArray.push(e.currentTarget.value);
			}else if(!e.currentTarget && valueArray.includes(e.currentTarget.value)){
				valueArray.splice(valueArray.indexOf(e.currentTarget.value), 1);
			}
			if(!valueArray || valueArray.length == 0){
				this.value = '[]';
			}else{
				this.value = JSON.stringify(valueArray);	
			}
		}
		get value(){
			if(this.data.get('value')){
				return this.data.get('value');
			}else{
				this.value = '[]';
				return this.data.get('value');
			}
		}
		set value(val){
			return this.data.set('value', val)
		}
	}
)

window.application.register("conditional-field", 
	// <div data-controller="conditional-field"
	// data-conditional-field-condition="document.getElementById('city').value!='Metro Manila'"
	
	class extends Stimulus.Controller {
		connect(){
			//expose controller to element["date"]
			this.element[this.identifier] = this;
			this.form = this.element.closest('form');

			if(this.form){
				this.form.addEventListener('change', this.onFormChange.bind(this));
			}
			this.onFormChange();
		}
		onFormChange(){
			try{
				
				if(eval(this.data.get('condition'))){
					if(this.element.classList.contains('hidden')){
						this.element.classList.remove('hidden');
						this.element.closest('form').dispatchEvent(new Event('updateView'));	
					}
					
				}else{
					if(!this.element.classList.contains('hidden')){
						this.element.classList.add('hidden');		
						this.element.closest('form').dispatchEvent(new Event('updateView'));
					}
				}
			}catch(err){
				// console.log(err);
				this.element.classList.add('hidden');	
			}
		}
		disconnect(){
			try{this.tearDown()}catch(err){};
		}
		tearDown(){
			if(this.form){
				this.form.removeEventListener('change', this.onFormChange.bind(this));
			}
		}
	}
)